import {isNotNilOrEmpty} from 'ramda-adjunct';

import {Nullish} from 'shared/web';

import {type FiltersType} from '../types/FiltersType';
import {type ClassifiedsRequestInput} from './omitHiddenVanFilters';

type OmitHiddenOriginCountryFilterParams = {
  filters: FiltersType;
  filterPresetId: string | Nullish;
  /** Filters stored in the applied preset. */
  presetFilters: FiltersType | Nullish;
  isOriginCountryFilterEnabled: boolean;
};

/**
 * With `sourcing_origin_country_filter` off the origin country has neither a field nor a chip, so
 * it must not filter the classifieds request – not from the filter state and not from a preset
 * saved while the flag was on. When `filterPresetId` is sent, the API rebuilds the filter from the
 * stored preset and would put the origin country back, so the preset id is dropped in that case
 * (applying a preset already hydrates its filters into the state the request is built from).
 */
export const omitHiddenOriginCountryFilter = (
  params: OmitHiddenOriginCountryFilterParams
): ClassifiedsRequestInput =>
  params.isOriginCountryFilterEnabled
    ? {filters: params.filters, filterPresetId: params.filterPresetId}
    : {
        filters: {...params.filters, originCountry: undefined},
        filterPresetId: isNotNilOrEmpty(params.presetFilters?.originCountry)
          ? null
          : params.filterPresetId,
      };
